import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import styles from './Skeleton.module.scss'
import { Item } from './Item'

const Skeleton = ({
  children = null,
  width = '100%',
  height = '100%',
  className = '',
  shown = false,
  as: Component = 'div',
  ...rest
}) => {
  if (!shown) {
    return null
  }
  return (
    <Component
      className={clsx(styles.skeleton, className)}
      style={{ width, height }}
      {...rest}
    >
      {children}
    </Component>
  )
}

Skeleton.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  shown: PropTypes.bool,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

Skeleton.Item = Item

export default Skeleton
